<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Import Journalists</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="p-8 w-full">
                    <form class="profile-form">
                        <div class="form-title">
                            <p class="text-lg font-light">Import</p>
                        </div>

                        <div class="form-field">
                            <input type="file" accept="text/csv" @change="handleFileImport">
                            <label>CSV Import File</label>
                        </div>
                    </form>

                    <div v-if="importData">
                        <div class="results-list">
                            <div class="results-row">
                                <div class="results-head" data-width="auto" v-for="(field, index) in importHeader">
                                    {{ field }}
                                    <fa-icon icon="times" class="text-red-500 cursor-pointer"
                                             @click="removeColumn(index)"/>
                                </div>
                            </div>
                            <div class="results-row">
                                <div class="results-cell" data-width="auto" v-for="(field, index) in importHeader">
                                    <select v-model="importFields[index]">
                                        <option :value="null">Ignore</option>
                                        <option v-for="(description, type) in fieldTypes" :value="type">{{
                                                description
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="results-row" v-for="row in importData">
                                <div class="results-cell truncate" data-width="auto" v-for="field in row">{{
                                        field
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm" v-if="importData">Import</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parse } from 'csv-parse'

export default {
    name: 'JournalistsImport',
    props: {
        //
    },
    data() {
        return {
            importHeader: null,
            importData: null,
            importFields: [],
            fieldTypes: {
                // 'id': 'ID (for update)',
                'email': 'Email Address',
                'firstname': 'First Name',
                'lastname': 'Last Name',
                'fullname': 'Full Name',
                'location': 'Locations (CSV)',
                'media_type': 'Media Type',
                'publication': 'Publication',
                'readership': 'Readership',
                'readership_source': 'Readership Source',
                'role': 'Role',
                'sector': 'Sectors (CSV)',
                'website': 'Website',
            },
        }
    },
    components: {
        //
    },
    computed: {
        //
    },
    mounted() {
        this.setMetaTitle('Import Journalists | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Journalists | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('journalists.import'), this.package())
                .then(response => {
                    this.$bus.$emit('alert.success', 'Import of user accounts has started')
                    this.closeView()
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Handle the uploading of a CSV file for importing
         *
         * @param   {Object}  event
         * @return  {void}
         */
        handleFileImport(event) {
            if (event.target.value !== '') {
                let files = event.target.files || event.dataTransfer.files
                if (!files.length) {
                    return
                }

                this.readFile(files[0])
            }
        },
        /**
         * Read the selected file and parse the CSV into header and content
         *
         * @param   {Object}  file
         * @return  {void}
         */
        readFile(file) {
            let reader = new FileReader()

            reader.onload = function (e) {
                const parser = parse({
                    trim: true,
                    skip_empty_lines: true,
                }, function (err, records) {
                    this.importHeader = records[0]
                    this.importData = records.slice(1)
                    this.importFields = []
                    for (let i = 0; i < this.importHeader.length; i++) {
                        this.importFields[i] = this.guessFieldType(this.importHeader[i])
                    }
                }.bind(this))
                parser.write(e.target.result)
                parser.end()
            }.bind(this)

            reader.readAsText(file)
        },
        /**
         * Guess the field type for a given field name string
         *
         * @param   {String}  field
         * @return  {String}
         */
        guessFieldType(field) {
            // Firstly, try all lowercase without spaces
            let lowercaseFieldCheck = field.toLowerCase().replace(/ /, '')
            if (typeof this.fieldTypes[lowercaseFieldCheck] !== 'undefined') {
                return lowercaseFieldCheck
            }

            // Now try with snake case
            let snakeCaseCheck = field.toLowerCase().replace(/ /, '_')
            if (typeof this.fieldTypes[snakeCaseCheck] !== 'undefined') {
                return snakeCaseCheck
            }

            // And now finally check for plurals
            let pluralCheck = field.toLowerCase().replace(/ /, '').slice(0, -1)
            if (typeof this.fieldTypes[pluralCheck] !== 'undefined') {
                return pluralCheck
            }

            return null
        },
        /**
         * Remove a column from the results
         *
         * @param   {Number}  index
         * @return  {void}
         */
        removeColumn(index) {
            this.importHeader.splice(index, 1)
            this.importData = this.importData.map((fields) => {
                fields.splice(index, 1)
                return fields
            })
            this.importFields.splice(index, 1)
        },
        /**
         * Package the results ready for sending to the server
         *
         * @return  {String}
         */
        package() {
            return {
                values: this.importData,
                fields: this.importFields,
            }
        },
    },
}
</script>

<style lang="less" scoped>
.results-list {
    max-width: 100%;
    overflow-x: auto;
}

.results-cell,
.results-head {
    min-width: 12rem;
}
</style>
